import axios from "axios";
import { cmsEnv, headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/custom/useToast";

export const fetchVacancies = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/vacancies`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchAcademicVacancies = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/vacancies-academic?sort=sort_order:asc`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};

export const fetchDownloadForms = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/download-form`,
      {
        headers: {
          ...headers,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(error.response.data.error.message);
  }
};
